import { useState } from "react";
import elevenLabsStatusService from "../services/elevenLabsStatus.service";
import { useKeepLiveRefresh } from "./useKeepLiveRefresh";

export const ELEVENLABS_STATUS_REFRESH_INTERVAL_MS = 600_000;

// A failed status request keeps the last known state: an unreachable status page
// is not evidence of an outage and must not trigger the banner on its own.
export const useElevenLabsDisruption = (): boolean => {
    const [isDisrupted, setIsDisrupted] = useState(false);

    useKeepLiveRefresh({
        immediate: true,
        intervalMs: ELEVENLABS_STATUS_REFRESH_INTERVAL_MS,
        refresh: async () => {
            setIsDisrupted(await elevenLabsStatusService.fetchHasEuDisruption());
        },
    });

    return isDisrupted;
};
